export default __webpack_public_path__ + "static/media/frog_R1_C2.e2faf721.png";